var _path, _path2, _path3, _g, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-st",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#12ad2b",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffce00",
    d: "M0 137.1h640V343H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d21034",
    d: "M0 0v480l240-240"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "st-c",
    transform: "translate(351.6 240) scale(.34286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "st-b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "st-a",
    d: "M0-200V0h100",
    transform: "rotate(18 0 -200)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#st-a",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#st-b",
    width: "100%",
    height: "100%",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#st-b",
    width: "100%",
    height: "100%",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#st-b",
    width: "100%",
    height: "100%",
    transform: "rotate(-144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#st-b",
    width: "100%",
    height: "100%",
    transform: "rotate(-72)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#st-c",
    width: "100%",
    height: "100%",
    x: 700,
    transform: "translate(-523.2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSt);
export default __webpack_public_path__ + "static/media/st.01db29dd376996dbbea328c25a0f987c.svg";
export { ForwardRef as ReactComponent };